
import login from '@/common/login';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
  name: 'VoteModule',
  components: {},
})
export default class VotePk extends Vue {
  @Prop({ default: false }) isPc!: boolean;
  @Prop({ default: '24px' }) fontSize!: string;
  @Prop({ default: 750 }) width!: number;
  @Prop({ default: 120 }) height!: number;
  @Prop({ default: 50 }) leftRatio!: number;
  @Prop({ default: 50 }) rightRatio!: number;
  @Prop({ default: 1 }) userCanVoteCount1!: number;
  @Prop({ default: 1 }) userCanVoteCount2!: number;
  @Prop() sonQuery!: any;
  len = 0;
  radian = null as any

  mounted() {
    // 处理斜切效果
    this.radian = ((this.isPc? 7 : 10) * Math.PI) / 180; // 将角度转换为弧度
    this.len = this.height * Math.sin(this.radian); // 计算直角短边的长度
  }

  get leftLongWidth() {
    return this.sonQuery?.leftLongWidth
  }

  get rightLongWidth() {
    return this.sonQuery?.rightLongWidth
  }

  get singleSide() {
    return this.sonQuery?.singleSide
  }

  get userCanVoteCheck1() {
    return this.userCanVoteCount1
  }

  get userCanVoteCheck2() {
    return this.userCanVoteCount2
  }


  get getProgressBlockStyle() {
    return (side: string) => {
      const curHeight = this.height;
      const width = side === 'left' ? this.leftLongWidth : this.rightLongWidth;
      const color = side === 'left' ? '#07aa6f' : '#f74699';
      // 把 rgb 转换为 rgba
      // const startColor = color.replace(
      //   /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
      //   "rgba($1, $2, $3, 1)"
      // );
      // const endColor = color.replace(
      //   /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
      //   "rgba($1, $2, $3, .6)"
      // );
      const style: any = {
        width: this.isPc?width + 'px' : width / 100 + 'rem',
        height: this.isPc?curHeight + 'px' : curHeight / 100 + 'rem',
        backgroundColor: color,
        // background: `linear-gradient(${
        //   side === "left" ? "to right" : "to left"
        // }, ${startColor}, ${endColor})`,
      };
      // 双边都有的情况下处理斜切效果
      if (!this.singleSide) {
        style.clipPath =
          side === 'left' ?
            `polygon(0% 0%, 100% 0%, ${
              ((width - this.len * 2) / width) * 100
            }% 100%, 0% 100%)` :
            `polygon(${
              ((this.len * 2) / width) * 100
            }% 0%, 100% 0%, 100% 100%, 0% 100%)`;
      }
      return style;
    };
  }
}
